import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { withRouter } from 'react-router'
import { onError } from 'lp-hoc'
import { logException } from 'sentry'
import {
  useCommunity,
  useDocumentTitle,
  useCommunityText,
  isMapEnabled,
  // initializeAnonymousUserflow,
} from 'utils'

const propTypes = {
  children: PropTypes.node,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
}

const defaultProps = {}

function Layout({ children, location, ...rest }) {
  const community = useCommunity()
  const { mapRedirectPath } = community
  const t = useCommunityText()

  // Block Community users from map if disabled
  if (!isMapEnabled(community) && mapRedirectPath) {
    window.location.pathname = mapRedirectPath
    return null
  }

  const baseTitle = t('map.title') || 'artlook Map: Increasing Arts Education'
  const path = (location && location.pathname) || ''

  let documentTitle = baseTitle
  if (path === '/faq' || path.endsWith('/faq')) {
    const custom = t('home.documentTitle.faq')
    documentTitle = custom ? `${custom} | ${baseTitle}` : `FAQ | ${baseTitle}`
  } else if (path === '/contact' || path.endsWith('/contact')) {
    const custom = t('home.documentTitle.contact')
    documentTitle = custom
      ? `${custom} | ${baseTitle}`
      : `Contact | ${baseTitle}`
  } else if (path === '/sitemap' || path.endsWith('/sitemap')) {
    documentTitle = `Site map | ${baseTitle}`
  }

  useDocumentTitle(documentTitle)

  // Temporarily disable userflow on public facing sites
  // initializeAnonymousUserflow()

  return <div {...rest}>{children}</div>
}

Layout.propTypes = propTypes
Layout.defaultProps = defaultProps

function onComponentDidCatch(_, error, errorInfo) {
  return logException(error, errorInfo)
}

export default compose(withRouter, onError(onComponentDidCatch))(Layout)
